import Util from '../../../lib/util.jsx'
import app from '../../../app.jsx'

export const getEstimatePdfUrl = estimate => {
  if (estimate) {
    const pdfFileName = Util.getPdfFileName(
      'estimate',
      estimate.estimateNumber,
      estimate.status
    )

    return encodeURI(
      `/estimate/preview/${app.getTeamId()}/${app.loggedInId}/${estimate.id ||
        ''}/${pdfFileName}`
    )
  }
  return ''
}

export const isEmptyEstimateItem = estimateItem =>
  // Checks if all the required fields defined in estimateItem schema exist
  !(
    estimateItem &&
    estimateItem.type &&
    estimateItem.estimateId
  )
